export default __webpack_public_path__ + "static/media/tz.cec8501c.svg";